import type { HTMLAttributes } from 'react'

import { cn } from './utils'

export type BadgeTone = 'neutral' | 'accent' | 'ok' | 'warn' | 'danger' | 'info' | 'auto' | 'reviewed' | 'kind'

const tones: Record<BadgeTone, string> = {
  neutral: 'bg-paper-2 text-ink-2 border-line',
  accent: 'bg-accent-soft text-ink border-transparent',
  ok: 'bg-ok-soft text-ok border-transparent',
  warn: 'bg-warn-soft text-warn border-transparent',
  danger: 'bg-danger-soft text-danger border-transparent',
  info: 'bg-info-soft text-info border-transparent',
  /** Publishing tier `auto` ("bronze"). */
  auto: 'bg-warn-soft text-tier-auto border-transparent',
  /** Publishing tier `reviewed`. */
  reviewed: 'bg-ok-soft text-tier-reviewed border-transparent',
  /** Vocabulary kind: colour comes from `style={{ '--kind': ... }}`. */
  kind: 'kind-bg text-ink-fixed border-transparent',
}

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
  /** Leading dot in the tone colour (status ribbons). */
  dot?: boolean
}

/** Small, non-interactive label. For a clickable/removable one use `Chip`. */
export function Badge({ className, tone = 'neutral', dot = false, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium leading-5 whitespace-nowrap', tones[tone], className)}
      {...props}
    >
      {dot ? <span className="size-1.5 rounded-full bg-current" aria-hidden /> : null}
      {children}
    </span>
  )
}
